import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from "@mui/material"
import { ReactElement, useContext } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch } from "../../../hooks/useDispatch"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { setShowAccountSetUp } from "../../../redux/preferencesSlice"
import { CLOSED } from "../../../redux/types"
import { GEN_DEVICE_SEARCH } from "../../../router/routes"
import AppButton from "../../buttons/appButton"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import {
    HAS_EXISTING_DEVICES,
    ORG_DETAILS_FORM_MANU,
    SELECT_ORG_TYPE,
} from "../screenDispatchers/firstLoginConstants"

/** Displayed to manufacturers to check if they have existing devices */
const ExistingDevicesCheck = (): ReactElement => {
    const { setCurrentScreen } = useContext(AccountSetUpContext)
    const { onSignOut } = useGetUserData()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="Have you any existing devices on Connect Direct registers?"
            subtitle="Any devices that were registered with ENA prior to the launch of Connect Direct have been migrated into the app. If you own any of these, let us know below so we can get you access to them!"
            content={
                <Stack justifyContent="flex-start" height="100%" spacing={3}>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        You can view our live device registers by{" "}
                        <Typography
                            variant="h6"
                            color="primary"
                            component="span"
                            sx={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                display: "inline",
                            }}
                            onClick={() => {
                                onSignOut()
                                dispatch(setShowAccountSetUp(CLOSED))
                                navigate(GEN_DEVICE_SEARCH)
                            }}
                        >
                            clicking here.
                        </Typography>{" "}
                        Clicking this will log you out. To get back to this
                        page, all you need to do is sign in again.
                    </Typography>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                        >
                            <FormControlLabel
                                value="No, I don't have existing devices"
                                control={<Radio />}
                                label="I do not have existing devices"
                                onClick={() =>
                                    setCurrentScreen(ORG_DETAILS_FORM_MANU)
                                }
                            />
                            <FormControlLabel
                                value="Yes, I have existing devices"
                                control={<Radio />}
                                label="I have existing devices"
                                onClick={() =>
                                    setCurrentScreen(HAS_EXISTING_DEVICES)
                                }
                            />
                        </RadioGroup>
                    </FormControl>
                </Stack>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        onClick={() => setCurrentScreen(SELECT_ORG_TYPE)}
                    >
                        Back
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default ExistingDevicesCheck
